<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-button">
      <Button
        v-if="hasWorkflowActions"
        size="tiny"
        type="secondary"
        :loading="dispatching"
        @click="dispatchWorkflowActions"
      >
        {{ field.label }}
      </Button>
      <Button v-else size="tiny" type="secondary" disabled>
        {{ field.label }}
      </Button>
      <ButtonFieldConfirmModal
        v-if="buttonFieldConfirmEnabled"
        ref="buttonFieldConfirmModal"
        :message="buttonFieldConfirmMessage"
        :confirm-label="field.label"
        @confirm="onButtonFieldConfirm"
        @cancel="onButtonFieldConfirmCancel"
      />
    </div>
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import buttonField from '@baserow/modules/database/mixins/buttonField'
import ButtonFieldConfirmModal from '@baserow/modules/database/components/field/ButtonFieldConfirmModal'

export default {
  name: 'GridViewFieldButtonField',
  mixins: [gridField, buttonField],
}
</script>
